module.exports = __webpack_public_path__ + "0fcffc52f58450bade62a5f5ca95430f.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/assets/fonts/hmr.ttf
 ** module id = 31
 ** module chunks = 0
 **/